import pose from "popmotion-pose"

export const formAdmin = () => {
  const replayProps = {
    initialPose: "hide",
    show: {
      opacity: 1,
      y: 0,
      maxHeight: 999,
      transition: { duration: 500, ease: "easeOut" }
    },
    hide: {
      opacity: 0,
      y: 30,
      maxHeight: 0,
      transition: { duration: 200 }
    }
  }
  const reples = Array.from(document.querySelectorAll(".reply"))
  if (reples) {
    reples.map(reply => {
      const form = reply.querySelector("form")
      const replyPoser = pose(form, replayProps)
      reply.querySelector(".reply-button").addEventListener("click", e => {
        e.preventDefault()
        replyPoser.set("show")
        form.classList.add("reviews-form-active")
      })
      reply.querySelector(".cancel").addEventListener("click", e => {
        e.preventDefault()
        replyPoser.set("hide")
        form.classList.remove("reviews-form-active")
      })
    })
  }
}
